import React from 'react';
import loadable from '@loadable/component';

/* istanbul ignore next */
export default loadable(() => import(/* webpackChunkName: "ReviewPage" */ './ReviewPage'), {
    fallback: <div />,
});
